import { render, staticRenderFns } from "./PrivateRatesFilters.vue?vue&type=template&id=c230ff54&"
import script from "./PrivateRatesFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrivateRatesFilters.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PrivateRatesFilters.vue?vue&type=style&index=0&id=c230ff54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports